/**
 * Store JSON-encoded data in localStorage or sessionStorage
 */
export class Storage {
	/**
	 * @param {WebStorage} engine  The localStorage or sessionStorage object
	 */
	constructor(engine) {
		/**
		 * The engine that has methods getItem, setItem, removeItem, and clear
		 * @type {WebStorage}
		 */
		this.engine = engine;
	}

	/**
	 * Get the data with the given key
	 * @param {String} key
	 * @returns {*}
	 */
	getItem(key) {
		try {
			let raw = this.engine.getItem(key);
			return raw ? JSON.parse(raw) : undefined;
		} catch (e) {
			// catch localStorage/sessionStorage NS_ERROR_FILE_CORRUPTED exception or JSON.parse exception
			return undefined;
		}
	}

	/**
	 * Set data by the given key. Data is JSON-encoded before being stored.
	 * @param {String} key
	 * @param {*} value
	 */
	setItem(key, value) {
		try {
			this.engine.setItem(key, JSON.stringify(value));
		} catch (e) {
			// catch localStorage/sessionStorage NS_ERROR_FILE_CORRUPTED exception or JSON.stringify exception
		}
	}

	/**
	 * Delete data at the given key
	 * @param {String} key
	 */
	removeItem(key) {
		try {
			this.engine.removeItem(key);
		} catch (e) {
			// catch localStorage/sessionStorage NS_ERROR_FILE_CORRUPTED exception
		}
	}

	/**
	 * Clear all data from storage
	 */
	clear() {
		try {
			this.engine.clear();
		} catch (e) {
			// catch localStorage/sessionStorage NS_ERROR_FILE_CORRUPTED exception
		}
	}
}
